export interface BankAccount {
  account: string
  bank: string
  holder: string
}

export interface FacebookAccount {
  url: string
  label: string
}

export interface ScammerInfo {
  id: number
  phone?: string
  phones?: string[]
  name?: string
  alias?: string
  facebook?: string
  facebookLabel?: string
  facebooks?: FacebookAccount[]
  bankAccount?: string
  bankName?: string
  bankHolder?: string
  bankAccounts?: BankAccount[]
  tiktok?: string
  images: string[]
}

export function getSlug(scammer: ScammerInfo): string {
  const base = scammer.alias || scammer.name
  if (base) return base.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-]/g, "")
  if (scammer.phone) return scammer.phone
  return String(scammer.id)
}

export function findBySlug(slug: string): ScammerInfo | undefined {
  return scammerList.find((s) => getSlug(s) === slug)
}

export function extractFbId(url: string): string {
  const m = url.match(/[?&]id=(\d+)/)
  return m ? m[1] : ""
}

export const scammerList: ScammerInfo[] = [
  {
    id: 1,
    phone: "085789452810",
    alias: "Pak Zupri / Indah Sari",
    facebook: "https://www.facebook.com/profile.php?id=61556758512803",
    facebookLabel: "Akun FB Pak Zupri / Indah Sari",
    images: [
      "/images/penipu/085789452810.png",
      "/images/penipu/085789452810_2.png",
    ],
  },
  {
    id: 2,
    phone: "081399017341",
    images: [
      "/images/penipu/081399017341.png",
    ],
  },
  {
    id: 3,
    name: "Komplotan Penipu",
    alias: "Komplotan Penipu",
    facebook: "https://www.facebook.com/profile.php?id=61582291287988",
    facebookLabel: "Akun FB Umar Dan Nur",
    facebooks: [
      { url: "https://web.facebook.com/profile.php?id=61582241812149", label: "Akun FB Jaya Farms" },
      { url: "https://web.facebook.com/profile.php?id=61581968919890", label: "Akun FB Salim Hidayat" },
    ],
    images: ["/images/penipu/Komplotan Penipu.png"],
  },
  {
    id: 4,
    name: "Ardan Barokah",
    alias: "Ardan Barokah",
    phone: "081994083393",
    bankAccount: "0391458447",
    bankName: "BCA",
    bankHolder: "Dahlan Cahya Sasra",
    facebook: "https://www.facebook.com/profile.php?id=61572535013786",
    facebookLabel: "Akun FB Ardan Barokah",
    images: [
      "/images/penipu/081994083393.png",
    ],
  },
  {
    id: 5,
    phone: "082379439802",
    name: "Al Frams",
    alias: "Gilang Ramadhan",
    facebook: "https://web.facebook.com/profile.php?id=100037947014491",
    facebookLabel: "Gilang Ramadhan",
    images: [
      "/images/penipu/082379439802.png",
    ],
  },
  {
    id: 6,
    name: "Muhammad Faiz Falah",
    alias: "Muhammad Faiz Falah / l Huda Poultry",
    facebook: "https://web.facebook.com/profile.php?id=100064992098016",
    facebookLabel: "Akun FB Muhammad Faiz Falah / Al Huda Poultry / Al Faruq Farm",
    phone: "08138305302",
    images: [
      "/images/penipu/08138305302.png",
    ],
  },
  {
    id: 7,
    alias: "Yoga P (Kandang Terpal)",
    phone: "085806939575",
    facebook: "https://www.facebook.com/profile.php?id=100053964874423",
    facebookLabel: "Akun FB Yoga P (Kandang Terpal)",
    images: [
      "/images/penipu/085806939574.png",
    ],
  },
  {
    id: 8,
    alias: "Agen Bibit",
    phone: "085854982370",
    facebook: "https://www.facebook.com/ketikahuda.harusmoveon",
    facebookLabel: "Akun FB Agen Bibit",
    images: [
      "/images/penipu/085854982370.png",
    ],
  },
  {
    id: 9,
    alias: "Wahyu Bird Farm",
    phone: "083179514862",
    facebook: "https://www.facebook.com/wahyu.birdfarm.2025/",
    facebookLabel: "Akun FB Wahyu Bird Farm",
    images: [],
  },
  {
    id: 10,
    alias: "Duwi Juwanto",
    phone: "088980447973",
    facebook: "https://www.facebook.com/profile.php?id=61571847704462",
    facebookLabel: "Akun FB Duwi Juwanto",
    images: [
      "/images/penipu/088980447973.png",
    ],
  },
  {
    id: 11,
    alias: "Desi Lawati",
    bankAccount: "554901005473508",
    bankName: "BRI",
    bankHolder: "Desi Lawati",
    images: [],
  },
  {
    id: 12,
    phone: "08131511738",
    name: "Jaya Unggas Sejahtera",
    alias: "Jaya Unggas Sejahtera / Peternak Mandiri Amanah",
    facebook: "https://web.facebook.com/profile.php?id=61581658873343",
    facebookLabel: "Akun FB Jaya Unggas Sejahtera",
    facebooks: [
      { url: "https://www.facebook.com/profile.php?id=61582346516219", label: "Akun FB Ismail Sholeh" },
    ],
    images: [
      "/images/penipu/08131511738.png",
      "/images/penipu/Ismail Sholeh.png",
      "/images/penipu/Ismail Sholeh_2.png",
    ],
  },
  {
    id: 13,
    name: "Alzio Fams",
    alias: "Alzio Fams",
    phone: "083121601828",
    facebook: "https://web.facebook.com/profile.php?id=61570929224554",
    facebookLabel: "Akun FB Alzio Fams",
    images: [],
  },
  {
    id: 14,
    name: "Rizky Pamungkas",
    alias: "Rizky Pamungkas",
    facebook: "https://web.facebook.com/profile.php?id=61556581155577",
    facebookLabel: "Akun FB Rizky Pamungkas",
    images: [],
  },
  {
    id: 15,
    name: "Kandang Nurjanis",
    alias: "Kandang Nurjanis",
    facebook: "https://www.facebook.com/share/16UgHeWy8k/",
    facebookLabel: "Akun FB Kandang Nurjanis",
    images: [],
  },
  {
    id: 16,
    name: "Kejora Brider Farm",
    alias: "Kejora Brider Farm",
    facebook: "https://web.facebook.com/profile.php?id=100089964287282",
    facebookLabel: "Akun FB Kejora Brider Farm",
    images: [],
  },
  {
    id: 17,
    name: "Maulana Dandi",
    alias: "Maulana Dandi",
    facebook: "https://web.facebook.com/profile.php?id=61552715251831",
    facebookLabel: "Akun FB Maulana Dandi",
    images: [],
  },
  {
    id: 18,
    name: "Nur Janis",
    alias: "Nur Janis",
    phone: "083175910867",
    facebook: "https://web.facebook.com/profile.php?id=61577140505329&rdid=oQFNcgWGtd1OHg0W",
    facebookLabel: "Akun FB Nur Janis",
    images: [],
  },
  {
    id: 19,
    name: "Layinatus Syifa",
    alias: "Layinatus Syifa",
    phone: "081376940819",
    facebook: "https://www.facebook.com/share/1BJDxYcs8R/",
    facebookLabel: "Akun FB Layinatus Syifa",
    images: [],
  },
  {
    id: 20,
    name: "Bagol Yasin",
    alias: "Bagol Yasin",
    phone: "0895339201223",
    phones: ["085282691762"],
    facebook: "https://www.facebook.com/share/19dca84WZz/",
    facebookLabel: "Akun FB Bagol Yasin",
    bankAccount: "7006642356",
    bankName: "BCA",
    bankHolder: "Muhamad Yasin",
    bankAccounts: [
      { account: "1949287931", bank: "BNI", holder: "Hayu Kakuhese" },
      { account: "5305-0103-2639-537", bank: "BRI", holder: "Nabila Dewi Anggrian" },
    ],
    images: [],
  },
  {
    id: 21,
    name: "Manda Fram",
    alias: "Manda Fram",
    phone: "082245174896",
    facebook: "https://www.facebook.com/share/1BRSTdyqs8/",
    facebookLabel: "Akun FB Manda Fram",
    images: [],
  },
  {
    id: 22,
    name: "Satria Janur",
    alias: "Satria Janur / Exotic Bird Farm",
    phone: "089665926767",
    phones: ["082197007937"],
    facebook: "https://web.facebook.com/profile.php?id=61550001816954",
    facebookLabel: "Satria Janur / Exotic Bird Farm",
    bankAccount: "901684379853",
    bankName: "SEABANK",
    bankHolder: "Robi Abdul Hadi",
    images: [],
  },
  {
    id: 23,
    name: "Bagus Aditya",
    phone: "",
    facebook: "https://web.facebook.com/profile.php?id=100091938425111",
    facebookLabel: "Akun FB Bagus Aditya",
    images: [
      "/images/penipu/100091938425111.png"
    ]
  },
  {
    id: 24,
    name: "AF Riko",
    phone: "083857083970",
    facebook: "https://web.facebook.com/profile.php?id=61581579466485",
    facebookLabel: "Akun FB AF Riko",
    images: [],
  },
  {
    id: 25,
    name: "Putra Mandiri Farm",
    alias: "Sobatternakfarm21",
    phone: "085173398982",
    tiktok: "https://www.tiktok.com/@sobatternakfarm21",
    bankAccount: "1850007916908",
    bankName: "MANDIRI",
    bankHolder: "Dedek Riyanto",
    images: [],
  },
  {
    id: 26,
    name: "Moch Ahmad",
    phone: "081239935622",
    facebook: "https://web.facebook.com/profile.php?id=100093165696273",
    facebookLabel: "Akun FB Moch Ahmad",
    images: [],
  },
  {
    id: 27,
    name: "Sahrul Syaputra",
    alias: "Sahrul Syaputra / Kayin Yayin CV.unggas Jaya Ternak",
    phone: "087875606301",
    facebook: "https://web.facebook.com/profile.php?id=61562943659097",
    facebookLabel: "Sahrul Syaputra / Kayin Yayin / CV.unggas Jaya Ternak",
    images: [],
  },
  {
    id: 28,
    name: "Birdrama Dede",
    alias: "Birdrama Dede",
    facebook: "https://web.facebook.com/birdframs.dede/",
    facebookLabel: "Akun FB Birdrama Dede",
    images: [],
  },
  {
    id: 29,
    name: "Ficy Vanti",
    alias: "Ficy Vanti",
    phone: "085801683782",
    bankAccount: "689001039790532",
    bankName: "BRI",
    bankHolder: "Ficy Vanti",
    images: [
      "/images/penipu/085801683782.png",
    ],
  },
  {
    id: 30,
    name: "Lulus Ayahe Sakha",
    alias: "Lulus Ayahe Sakha",
    phone: "085695551910",
    phones: ["0895622183716"],
    facebook: "https://web.facebook.com/gunadi.handoko.73/",
    facebookLabel: "Akun FB Lulus Ayahe Sakha",
    images: [
      "/images/penipu/085695551910.png",
    ],
  },
  {
    id: 31,
    name: "Erick Wahyu Saputra / Ayam Import",
    alias: "Erick Wahyu Saputra / Ayam Import",
    phone: "083194297786",
    facebook: "https://web.facebook.com/profile.php?id=61575317490836",
    facebookLabel: "FB Erick Wahyu Saputra Ayam Import",
    bankAccount: "067101002340536",
    bankName: "BRI",
    bankHolder: "Erick Wahyu Saputra",
    images: [
      "/images/penipu/083194297786.png",
    ],
  },
]
